/* eslint-disable no-debugger */
/* eslint-disable no-console */
import 'whatwg-fetch'; // fetch polyfill

const searchForm = () => {
	const queryForm = document.querySelector('.c-searchform');
	// eslint-disable-next-line no-unused-vars
	const sfSubmitButton = document.querySelector('.c-searchform__submit');
	const sfQueryText = document.querySelector('.c-searchform__q');
	const resultsWrapper = document.querySelector('.c-search-results');
	const resultOpenClass = 'open';
	const resultsClass = '.c-search-results__results';
	const paginationClass = '.c-search-results__items .pagination';
	// const paginationPageClass = '.c-search-results__items .pagination a';
	const sortResults = document.querySelector('.c-search-results__select');
	const nextButtonClass = '.c-search-results #next';
	const prevButtonClass = '.c-search-results #prev';

	let nextPageIndex = -1;
	let prevPageIndex = -1;

	const getFormattedSearchResult = item => `<div class="c-search-results__result">
													<a href='${item.link}' class="title">${item.title}</a>
													<div class="link">${item.formattedUrl}</div>
													<div class="snippet">${item.snippet}</div>
												</div>`;

	const noSearchResult = "<div class='c-search-results__result'><a href='javascript:void(0);' class='title'>No Results found</a></div>";

	const makeWrapperVisible = () => {
		resultsWrapper.classList.add(resultOpenClass);
		// resultsWrapper.setAttribute('role', 'dialog');
		resultsWrapper.setAttribute('aria-hidden', false);
	};

	const replaceSpecials = (data) => {
		const returnData = data.replace(/[^0-9a-zA-Z]+/, ' ');
		return returnData;
	};

	const updateNoResults = () => {
		document.querySelector('.c-search-results__count').innerHTML = '';
		// template
		document.querySelector(resultsClass).innerHTML = noSearchResult;
		document.querySelector(paginationClass).classList.add('d-none');
		document.querySelector('.c-search-results__order').classList.add('d-none');
		prevPageIndex = -1;
		nextPageIndex = -1;
		// disable both next and prev buttons
		document.querySelector(nextButtonClass).classList.add('disabled');
		document.querySelector(prevButtonClass).classList.add('disabled');
	};

	const updateSearchResults = (data) => {
		document.querySelector(resultsClass).innerHTML = '';
		// document.querySelector('.c-search-results__items .pagination .col-12').innerHTML = '';
		document.querySelector(paginationClass).classList.remove('d-none');
		const responseData = data;
		if (responseData.searchInformation.totalResults === '0') {
			updateNoResults();
		} else {
			document.querySelector('.c-search-results__count').innerHTML = `About ${responseData.searchInformation.totalResults} results`;

			document.querySelector(prevButtonClass).classList.remove('disabled');
			document.querySelector(nextButtonClass).classList.remove('disabled');
			if (responseData.queries.previousPage !== undefined) {
				prevPageIndex = responseData.queries.previousPage[0].startIndex;
				// enable the prev button
			} else {
				prevPageIndex = -1;
				// disable the prev button
				document.querySelector(prevButtonClass).classList.add('disabled');
			}

			if (responseData.queries.nextPage !== undefined) {
				nextPageIndex = responseData.queries.nextPage[0].startIndex;
				// enable the next button
			} else {
				nextPageIndex = -1;
				// disable the next button
				document.querySelector(nextButtonClass).classList.add('disabled');
			}

			// template
			// eslint-disable-next-line guard-for-in
			responseData.items.forEach((item) => {
				document.querySelector(resultsClass).innerHTML += getFormattedSearchResult(item);
			});
		}
		makeWrapperVisible();
	};

	const getSearchResults = (startIndex) => {
		// if (startIndex === 1) {
		// 	document.querySelector(`${paginationPageClass}.active`).classList.remove('active');
		// 	allpageLinks.item(0).classList.add('active');
		// }

		if (sfQueryText) {
			const searchString = sfQueryText.value;
			const sortByDate = sortResults.value === 'date';
			if (searchString === '' || startIndex === -1) {
				return;
			}

			// let endpoint = `https://www.googleapis.com/customsearch/v1/siterestrict?cx=013976437620768797427:082utpenuhp&key=AIzaSyAUf6HcurV7TtGYIa8mv0EW2OpfQLSKrn8&fields=kind,searchInformation/totalResults,items(title,link,snippet,formattedUrl),queries/nextPage(searchTerms,count,startIndex),queries/previousPage(searchTerms,count,startIndex)&q=${searchString}&start=${startIndex}`;
			let endpoint = `/api/search/websitesearch/${replaceSpecials(searchString)}/${startIndex}`;

			if (sortByDate) {
				endpoint += '/1';
			}

			fetch(endpoint, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				}
			}).then(r => r.json())
				.then((response) => {
					// console.log(response);
					// if (response.status !== 200) {
					// eslint-disable-next-line max-len
					// 	console.log(`Looks like there was a problem with search. Status Code :${response.status}`);
					// 	return;
					// }
					updateSearchResults(JSON.parse(response));
					return response;
				})
				.catch((error) => {
					console.log(`Error reproted by search : ${error}`);
					updateNoResults();
				});
		}
	};

	// eslint-disable-next-line no-unused-vars
	const close = () => {
		resultsWrapper.removeAttribute('role');
		resultsWrapper.removeAttribute('aria-modal');
		resultsWrapper.classList.remove(resultOpenClass);
	};

	// const keyboardHandler = (e) => {
	// 	if (e.keyCode === 27) {
	// 		close();
	// 	}
	// };

	const getNextPageResult = () => {
		getSearchResults(nextPageIndex);
	};

	const getPrevPageResult = () => {
		getSearchResults(prevPageIndex);
	};


	if (queryForm) {
		sfSubmitButton.addEventListener('click', (e) => { e.preventDefault(); getSearchResults(1); });
		document.querySelector(nextButtonClass).addEventListener('click', () => getNextPageResult());
		document.querySelector(prevButtonClass).addEventListener('click', () => getPrevPageResult());
		// drop down change event
		sortResults.addEventListener('change', () => getSearchResults(1));
	}
};

export default searchForm;

/* eslint-enable no-console */
/* eslint-enable no-debugger */
